import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import cn from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useBranchPreBlockWarning } from '@app/components/BillingStatusBanner/hooks/useBranchPreBlockWarning';
import { useTopBannerOffset } from '@app/shared/hooks';

import './styles/BillingStatusBanner.desktop.scss';

const ROOT_CLASS = 'bc-billing-status-banner';
const { Text } = Typography;

export const BillingStatusBanner = () => {
  const { showWarning, text } = useBranchPreBlockWarning();
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);
  const bannerRef = useRef<HTMLDivElement>(null);

  const show = showWarning && Boolean(text) && !dismissed;

  // Сдвигаем лейаут вниз, чтобы баннер не перекрывал верх сайдбара
  useTopBannerOffset('billing-status', bannerRef, show);

  // Новое предупреждение (pre-block/ai-warning) должно снова показать полосу,
  // даже если её закрыли
  useEffect(() => {
    if (showWarning) setDismissed(false);
  }, [showWarning]);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const handleClose = useCallback(() => {
    setDismissed(true);
  }, []);

  if (!show) return null;

  return (
    <div
      ref={bannerRef}
      className={cn(ROOT_CLASS, { [`${ROOT_CLASS}--visible`]: visible })}
    >
      <WarningOutlined className={`${ROOT_CLASS}__icon`} />
      <Text className={`${ROOT_CLASS}__text`}>{text}</Text>
      <button
        type="button"
        className={`${ROOT_CLASS}__close`}
        onClick={handleClose}
      >
        <CloseOutlined />
      </button>
    </div>
  );
};
